import styled from 'styled-components';

// The wireframe's "vp-row": a label followed by the person's name chip (or the italic "Unclaimed")
export const OwnerRowStyled = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  color: ${p => p.theme?.colors?.gray ?? '#565E70'};
`;

export const OwnerLabelStyled = styled.span`
  margin-right: 2px;
`;

// The wireframe's small person chip (".pchip.sm"): initials avatar + name
export const PersonChipStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 20px;
  padding: 0 8px 0 3px;
  border: 1px solid ${p => p.theme?.colors?.border ?? '#D8DAE5'};
  border-radius: 11px;
  background: ${p => p.theme?.colors?.white ?? '#ffffff'};
  color: ${p => p.theme?.colors?.gray ?? '#565E70'};
  font-size: 12px;
  white-space: nowrap;
`;

export const PersonAvatarStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${p => p.theme?.colors?.primary ?? '#0155e7'};
  color: ${p => p.theme?.colors?.white ?? '#ffffff'};
  font-size: 8px;
  font-weight: 600;
`;

export const UnclaimedStyled = styled.i`
  cursor: default;
`;

// "No one" when nobody holds the JD as delegate (the wireframe's ".vp-none")
export const NoOneStyled = styled.i`
  color: ${p => p.theme?.colors?.tertiary ?? '#8790A4'};
`;

// The × on a chip (take back / relinquish) and the + after the row (add), as small buttons
export const ChipRemoveStyled = styled.button`
  border: none;
  background: none;
  padding: 0 0 0 2px;
  cursor: pointer;
  color: ${p => p.theme?.colors?.tertiary ?? '#8790A4'};
  font-size: 13px;
  line-height: 1;

  &:hover {
    color: ${p => p.theme?.colors?.danger ?? '#DC2626'};
  }
`;

export const ChipAddStyled = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 1px dashed #bfbfbf;
  border-radius: 11px;
  background: ${p => p.theme?.colors?.white ?? '#ffffff'};
  color: ${p => p.theme?.colors?.primary ?? '#0155e7'};
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  padding: 0;
`;
